/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-shadow */

import { datetimeToDate, numberToMoney } from 'helper/utils'
import * as Yup from 'yup'
import { setLocale } from 'yup'

interface Props {
  index: number
  name: string
  value: string
  arr: any[]
  setArr: any
  unit: boolean
  data: any
}

export const handleCaptation = (
  captation: any,
  selectOptions: any,
  toggleCap: any
) => {
  const { data, enterprise } = captation
  // console.log('dados do get da cap', captation)
  const parsed = {
    ...captation,
    ...data,
    ...enterprise,
    style: captation.style,
    capMin: data.minInvest,
    minInvest: undefined,
    captationQuotas: undefined,
    deadline: undefined,
    captationId: captation?.id,
    maxSupply: undefined,
    profitability: undefined,
    releaseAt: datetimeToDate(new Date(captation?.releaseAt)),
    quotaAmount: (enterprise.value * enterprise.amount) / enterprise.quotaValue,
    guaranteeList:
      captation.guaranteeList.length > 0
        ? captation.guaranteeList.map((item: any) => {
            return {
              label: item,
              value: item,
            }
          })
        : [{ label: 'Não possui', value: 'Não possui' }],
    name: `${enterprise.name}${
      toggleCap === 'Captação aberta' ? ' ' : ` Personal `
    }${captation?.nextTokenNumber}`,
    shortName: `${enterprise.shortName}${
      toggleCap === 'Captação aberta' ? ' ' : ` Personal `
    }${captation?.nextTokenNumber}`,
    tick: `${enterprise.tick}${captation?.nextTokenNumber}`,
  }
  let newOb: any = parsed

  const Arr = Object.keys(selectOptions)
  Arr.forEach((item: any) => {
    if (item === 'guaranteeList') return newOb
    newOb = {
      ...newOb,
      [item]: selectOptions[item].find((la: any) => la.value === parsed[item]),
    }
  })
  return newOb
}

export const fixName = (data: any, isPersonal: boolean, entr: any) => {
  return {
    ...data,
    name: `${data.name}${isPersonal ? ` Personal ` : ' '}${
      data?.nextTokenNumber
    }`,
    shortName: `${data.shortName}${isPersonal ? ` Personal ` : ' '}${
      data?.nextTokenNumber
    }`,
    tick: `${data.tick}${data.nextTokenNumber}`,
    enterpriseId: entr?.id,
  }
}

setLocale({
  mixed: {
    default: 'Não é válido',
  },
})
interface Data {
  amount?: number
  value?: number
  quotaValue?: number
  minInvest?: number
  maxSupply?: number
  totalAvailable?: number
  icoPeriod?: { label: string; value: string }
  releaseAt?: string
  startedAt?: string
  tradeAt?: string
  createdAt?: string
  profitabilityBonus?: number
  bonusMonths?: { value: number; label: string }
  guaranteeList?: { value: string; label: string }
  capMin?: number
  available?: number
  ruleList?: any
}

interface SchemaNewCaptionParams {
  formatedData: Data
  rule: boolean
  bonus: boolean
  toggleCap: string
}

export const schemaNewCaption = ({
  formatedData,
  rule,
  bonus,
}: SchemaNewCaptionParams) => {
  return Yup.object()
    .shape({
      type: Yup.object().required('Campo obrigatório'),
      totalAvailable: Yup.number(),
      maxSupply: Yup.number()
        .typeError('Deve ser um número válido')
        .required('Campo obrigatório')
        .test('maxSupply-check', function () {
          let errorMessage = ''
          if (formatedData?.ruleList) return true
          if (
            Number(formatedData?.maxSupply) >
            Number(formatedData?.totalAvailable)
          ) {
            errorMessage = `A quantidade de cotas máxima é ${Number(
              formatedData?.totalAvailable
            )}`
            return this.createError({ message: errorMessage })
          }
          if (
            Number(formatedData?.maxSupply) > Number(formatedData?.available)
          ) {
            errorMessage = `A quantidade de cotas máxima é ${Number(
              formatedData?.available
            )}`
            return this.createError({ message: errorMessage })
          }
          if (
            Number(formatedData?.minInvest) / Number(formatedData?.quotaValue) >
            Number(formatedData?.maxSupply)
          ) {
            errorMessage = `A quantidade de cotas mínima é ${
              Number(formatedData?.minInvest) / Number(formatedData?.quotaValue)
            }`
            return this.createError({ message: errorMessage })
          }

          return true // Total available as vezes é undefined e não pode ser comparado
        }),
      minInvest: Yup.number()
        .typeError('Deve ser um valor válido')
        .min(1)
        .required('Campo obrigatório')
        .test('minInvest', function () {
          let errorMessage = ''

          if (
            formatedData?.capMin &&
            Number(formatedData?.minInvest) < Number(formatedData?.capMin)
          ) {
            errorMessage = `O Valor mínimo para investir é R$ ${numberToMoney(
              formatedData?.capMin
            )}`
            return this.createError({ message: errorMessage })
          }

          if (
            Number(formatedData?.minInvest) < Number(formatedData?.quotaValue)
          ) {
            errorMessage = `O valor mínimo para investir é R$ ${numberToMoney(
              Number(formatedData?.quotaValue)
            )}`
            return this.createError({ message: errorMessage })
          }
          // }

          if (!formatedData?.ruleList) return true
          if (
            Number(formatedData?.maxSupply) > Number(formatedData?.available)
          ) {
            errorMessage = `O valor máximo para investir é R$ ${numberToMoney(
              Number(formatedData?.available) * Number(formatedData?.quotaValue)
            )}`
            return this.createError({ message: errorMessage })
          }

          if (
            Number(formatedData?.maxSupply) >
            Number(formatedData?.totalAvailable)
          ) {
            errorMessage = `O valor máximo para investir é R$ ${numberToMoney(
              Number(formatedData?.totalAvailable) *
                Number(formatedData?.quotaValue)
            )}`
            return this.createError({ message: errorMessage })
          }
          return true // Total available as vezes é undefined e não pode ser comparado
        }),
      icoPeriod: Yup.object().required('Campo obrigatório'),
      releaseAt: Yup.string().when([], {
        is: () => rule,
        then: Yup.string(),
        otherwise: Yup.string().min(10).required('Campo obrigatório'),
      }),
      deadline: Yup.string().required('Campo obrigatório'),
      recurrencyType: Yup.object().required('Campo obrigatório'),
      principalLiquidityType: Yup.object().required('Campo obrigatório'),
      paymentType: Yup.object().required('Campo obrigatório'),
      profitability: Yup.string().min(1).required('Campo obrigatório'),
      IRType: Yup.object().required('Campo obrigatório'),
      cotizationIn: Yup.object().required('Campo obrigatório'),
      cotizationOut: Yup.object().required('Campo obrigatório'),
      isCotizationProfitable: Yup.object().required('Campo obrigatório'),
      enterpriseId: Yup.string().required('Campo obrigatório'),
      guaranteeList: Yup.array()
        .of(
          Yup.object().shape({
            label: Yup.string().required(),
            value: Yup.string().required(),
          })
        )
        .min(1, 'Selecione ao menos uma garantia')
        .required('Campo obrigatório'),
      profitabilityBonus: Yup.string().when([], {
        is: () => bonus,
        then: Yup.string().min(1).required('Campo obrigatório'),
        otherwise: Yup.string(),
      }),
      bonusMonths: Yup.object().when([], {
        is: () => bonus,
        then: Yup.object().nullable().required('Campo obrigatório'),
        otherwise: Yup.object().nullable(),
      }),
      ruleList: Yup.object({
        REQUIRED_ACCOUNT: Yup.array().when([], {
          is: () => rule,
          then: Yup.array().min(1).required('Campo obrigatório'),
          otherwise: Yup.array(),
        }),
      }),
    })
    .typeError('Este input deve ser preenchido corretamente')
}

export const schemaRetroativos = Yup.object().shape({
  enterpriseId: Yup.string().required('Campo obrigatório'),
  accountId: Yup.string().required('Campo obrigatório'),
  value: Yup.string().required('Campo obrigatório'),
  deadline: Yup.string().required('Campo obrigatório'),
  quotaValue: Yup.number().required('Campo obrigatório'),
  liquidity: Yup.object().required('Campo obrigatório'),
  paymentType: Yup.object().required('Campo obrigatório'),
  recurrencyType: Yup.object().required('Campo obrigatório'),
  investAt: Yup.string().required('Campo obrigatório'),
  firstAt: Yup.string().required('Campo obrigatório'),
  last: Yup.string().required('Campo obrigatório'),
  cotizationOut: Yup.object().required('Campo obrigatório'),
  isCotizationProfitable: Yup.object().required('Campo obrigatório'),
})

export const selectOptions: any = {
  accountList: [
    { label: 'Captação aberta', value: [] },
    { label: 'Captação fechada', value: [] },
  ],
  type: [
    { label: 'Cotas imobiliárias', value: 'SPE' },
    { label: 'SCP', value: 'SCP' },
    { label: 'CCB', value: 'CCB' },
    { label: 'Nota Comercial', value: 'NC' },
  ],
  guaranteeList: [
    { label: 'Seguro', value: 'Seguro' },
    { label: 'Alienação fiduciária', value: 'Alienação fiduciária' },
    { label: 'Aval dos sócios', value: 'Aval dos sócios' },
    { label: 'Não possui', value: 'Não possui' },
  ],
  icoDays: [
    { label: '7 dias', value: 7 },
    { label: '15 dias', value: 15 },
    { label: '30 dias', value: 30 },
    { label: '60 dias', value: 60 },
    { label: '90 dias', value: 90 },
    { label: 'Full', value: 0 },
  ],
  icoDaysPersonal: [
    { label: '7 dias', value: 7 },
    { label: '15 dias', value: 15 },
    { label: '30 dias', value: 30 },
    { label: '60 dias', value: 60 },
    { label: '90 dias', value: 90 },
  ],
  icoPeriod: [
    { label: '7 dias', value: 7 },
    { label: '15 dias', value: 15 },
    { label: '30 dias', value: 30 },
    { label: '60 dias', value: 60 },
    { label: '90 dias', value: 90 },
    { label: 'Full', value: 0 },
  ],
  recurrencyType: [
    // { label: 'Diária', value: 'DAILY' },
    { label: 'Mensal', value: 'MONTHLY' },
    { label: 'Trimestral', value: 'QUARTERLY' },
    // { label: 'Anual', value: 'ANNUALLY' },
    { label: 'No vencimento', value: 'DEFAULT' },
  ],
  principalLiquidityType: [
    { label: 'Diária', value: 'DAILY' },
    { label: 'Anual', value: 'ANNUALLY' },
    { label: 'No vencimento', value: 'DEFAULT' },
  ],
  paymentType: [
    { label: 'Pré fixado', value: 'PRE' },
    // { label: 'Pós fixado', value: 'POS' },
    // { label: 'Híbrido', value: 'HYBRID' },
  ],
  indiceId: [
    { label: 'IPCA', value: 'IPCA' },
    { label: 'IGP-M', value: 'IGP-M' },
    { label: 'CDI', value: 'CDI' },
  ],
  IRType: [
    { label: 'Descontado na fonte', value: 'Descontado na fonte' },
    { label: 'Não descontado na fonte', value: 'Não descontado na fonte' },
    { label: 'Isento', value: 'Isento' },
  ],
  cotizationIn: [
    { label: 'No dia', value: 0 },
    { label: '1 dia', value: 1 },
    { label: '5 dias', value: 5 },
    { label: '10 dias', value: 10 },
    { label: '15 dias', value: 15 },
    { label: '20 dias', value: 20 },
    { label: '30 dias', value: 30 },
    { label: '60 dias', value: 60 },
    { label: '90 dias', value: 90 },
  ],
  cotizationOut: [
    { label: 'Até 30 dias', value: 30 },
    { label: 'Até 60 dias', value: 60 },
    { label: 'Até 90 dias', value: 90 },
  ],
  isCotizationProfitable: [
    { label: 'Sim', value: 1 },
    { label: 'Não', value: 0 },
  ],
}

export const addRow = (unit: boolean, setArr: any, arr: any[]) => {
  if (!unit) {
    setArr([
      ...arr,
      {
        months: null,
        prof: null,
        id: `prof_${arr.length + 1}`,
      },
    ])
  }
  setArr([
    ...arr,
    {
      unit: null,
      percent: null,
      quotas: null,
      id: `row_${arr.length + 1}`,
    },
  ])
}

export const removeRow = (
  item: any,
  arr: any[],
  setArr: any,
  data: any,
  unit: boolean
) => {
  if (arr.length === 1) {
    return unit
      ? setArr([{ unit: null, percent: null, quotas: null, id: `row_1` }])
      : setArr([{ months: '', prof: '', id: `prof_1` }])
  }
  const newA = [...arr]
  const newb = newA.filter((row: any) => row.id !== item.id)
  if (!unit) {
    return setArr(newb)
  }
  const totalPercent = newb.reduce((sum: number, item: any) => {
    return sum + (Number(item.percent) ?? 0)
  }, 0)

  const ratio = Number(data?.amount) / Number(totalPercent)

  newb.forEach((element: any) => {
    const cotas = element.percent * ratio
    element.quotas = Number.isNaN(cotas) ? null : cotas
  })
  setArr(newb)
}

export const handleChangeUnit = (props: Props) => {
  const { index, name, value, arr, setArr, unit, data } = props
  const newRows: any = [...arr]
  newRows[index][name] = value
  if (!unit) {
    return setArr(newRows)
  }
  const totalPercent = newRows.reduce((sum: number, item: any) => {
    return sum + (Number(item.percent) ?? 0)
  }, 0)

  const ratio = Number(data?.amount) / Number(totalPercent)

  newRows.forEach((element: any) => {
    const cotas = element.percent * ratio
    element.quotas = Number.isNaN(cotas) ? null : cotas
  })

  setArr(newRows)
}

export const getAvailableMonths = (data: any, prof: any) => {
  if (!data?.deadline) return []
  const arr = []
  const sum = prof.reduce((sum: number, item: any) => {
    return sum + (Number(item.months) ?? 0)
  }, 0)
  const monthsAv = Number(data?.deadline) - sum
  for (let i = 0; i < monthsAv; i++) {
    arr.push({
      label: i + 1,
      value: i + 1,
    })
  }
  return arr
}

const formatMonth = (month: number) => {
  if (month + 1 < 10) return `0${month + 1}`
  return `${month + 1}`
}

export const calculateDates = (data: any, setData: any) => {
  const [day, month, year] = data?.firstAt.split('/')
  const [day2, month2, year2] = data?.investAt.split('/')

  const prazo = Number(data?.deadline) - 1

  const first = new Date(year, Number(month) - 1, day)
  const firstFormated = `${first.getFullYear()}-${formatMonth(
    first.getMonth()
  )}-${first.getDate()}`

  if (Number.isNaN(first.getTime())) return

  const lastDate = new Date(year, Number(month) - 1, day).setMonth(
    new Date(year, Number(month) - 1, day).getMonth() + prazo
  )
  const last = `${new Date(lastDate).getDate()}/${formatMonth(
    new Date(lastDate).getMonth()
  )}/${new Date(lastDate).getFullYear()}`
  const lastAt = `${new Date(lastDate).getFullYear()}-${formatMonth(
    new Date(lastDate).getMonth()
  )}-${new Date(lastDate).getDate()}`

  const rescueDate = new Date(lastDate).setDate(
    new Date(lastDate).getDate() + data?.cotizationOut.value
  )
  const rescueAt = `${new Date(rescueDate).getDate()}/${formatMonth(
    new Date(rescueDate).getMonth()
  )}/${new Date(rescueDate).getFullYear()}`

  setData((old: any) => ({
    ...old,
    investedAt: `${year2}-${month2}-${day2}`,
    startedAt: firstFormated,
    last,
    lastAt,
    rescueAt,
  }))
}

function isLeapYear(year: number): boolean {
  if (year % 4 === 0) {
    if (year % 100 === 0) {
      return year % 400 === 0
    }
    return true
  }
  return false
}

const daysInTheMonth = (month: number, year: number) => {
  const group1 = [0, 2, 4, 6, 7, 9, 11]
  const group2 = [3, 5, 8, 10]
  if (group1.includes(month)) {
    return 31
  }
  if (group2.includes(month)) {
    return 30
  }
  return isLeapYear(year) ? 29 : 28
}

export const calculateRentabilidade = (data: any, setData: any, prof: any) => {
  const [day, month, year] = data?.firstAt.split('/')
  const [day2, month2, year2] = data?.investAt.split('/')
  const first = new Date(year, Number(month) - 1, day)
  const start = new Date(year2, Number(month2) - 1, day2)
  const today = new Date()
  const todayDay = today.getDate()
  const firstDay = first.getDate()

  // Calculate the number of months that have passed since the first payment
  const monthsElapsed =
    (today.getFullYear() - first.getFullYear()) * 12 +
    (today.getMonth() - first.getMonth())

  // console.log('meses entre dia do pagamento e hoje', monthsElapsed)

  let totalProfitReceived = 0
  let remainingProfit = 0
  let totalMonthsElapsed = 0

  prof.forEach((period: any) => {
    for (let i = 0; i < Number(period.months); i++) {
      if (totalMonthsElapsed < monthsElapsed) {
        // console.log('caiu no primeiro if')
        totalProfitReceived += Number(data.value) * (Number(period.prof) / 100)
      } else if (totalMonthsElapsed === monthsElapsed && todayDay >= firstDay) {
        // console.log('caiu no segundo if')
        totalProfitReceived += Number(data.value) * (Number(period.prof) / 100)
      } else {
        // console.log('caiu no else')
        remainingProfit += Number(data.value) * (Number(period.prof) / 100)
      }
      totalMonthsElapsed += 1
    }
  })

  // console.log('antes do proporcional', totalProfitReceived, remainingProfit)

  // SE OS DIAS PROPORCIONAL FOR MAIOR QUE OS DIAS DE UM MES, TERA QUE REPENSAR O CALCULO
  // quando o dia do primeiro pagamento ocorre antes da data atual

  if (day > day2 && month > month2) {
    return setData((old: any) => ({
      ...old,
      paidProfitability: totalProfitReceived,
      toPayProfitability: remainingProfit,
    }))
  }

  const diferencaEmMilissegundos: any = first.getTime() - start.getTime()
  const milissegundosPorDia = 1000 * 60 * 60 * 24
  const diferencaEmDias = Math.floor(
    diferencaEmMilissegundos / milissegundosPorDia
  )

  const parcel1 = Number(data.value) * (Number(prof[0].prof) / 100)
  const trueParcel1 =
    (parcel1 * diferencaEmDias) /
    daysInTheMonth(start.getMonth(), start.getFullYear())

  // console.log('primeira parcela', parcel1, trueParcel1)
  const diferencaValor = parcel1 - trueParcel1

  totalProfitReceived -= diferencaValor
  // }

  return setData((old: any) => ({
    ...old,
    paidProfitability: totalProfitReceived,
    toPayProfitability: remainingProfit,
  }))
}

// getQuotaList () {
//   const list = [];
//   const proportional = utils.time.daysBetweenDates(this.investedAt, this.startedAt) - 1;
//   const totalAmount = this.value * this.amount;

//   const parcelList = this.paymentConditions.reduce((acc, cur) => {
//     const [rule, rate] = cur;
//     if (typeof rule !== 'number') return acc;
//     for (let i=0; i<rule; i++) acc.push(rate);
//     return acc;
//   }, []);

//   while (parcelList.length < this.totalQuota) parcelList.push(parcelList.at(-1));

//   for (let i=0; i<parcelList.length; i++) {
//     const proft = (parcelList[i] / 100) * totalAmount;
//     if (i === 0) {
//       const proportionalProfitability = ((proft / 30) * proportional);
//       list.push([this.startedAt, proportionalProfitability]);
//       continue;
//     }
//     list.push([utils.time.addMonthsToDate(this.startedAt, i), proft]);
//   }

//   return list;
// }

// acceptCupom : 0
// clientId : "6afa10fc-7173-4d6e-82c1-1ec4f709e721"
// contractList: "[]"
// createdAt: "2024-03-27T03:00:00.000Z"
// cupomList: "[]"
// data: {
//  IRType: "DEFAULT"
//  cotizationIn: 30
//  cotizationOut: 30
//  deadline: 15
//  fonetic: "Invest Test 1"
//  hasCETIP: false
//  minInvest: 1000
//  policyCommission: {}
// }
// documentList: "[]"
// enterprise: {
//   quotaValue  : 1000
//   value: 1000000
// }
// enterpriseId: "5ca460f1-1499-4fa3-abe6-827886ad6f98"
// gestorId: "86f31be6-9abb-4e96-8c8d-504613b9fb33"
// guaranteeList: "[\"FGC\"]"
// id: "c3ebdbdb-6ada-46dc-a38e-0a961847297e"
// indiceId: null
// interestLiquidityType: "MONTHLY"
// name: "Investimento de teste de plataforma 1"
// paymentType: "PRE"
// principalLiquidityType: "DEFAULT"
// profitability: 14
// recurrencyType: "MONTHLY"
// releaseAt: "2024-03-27T19:07:07.000Z"
// ruleList: "{}"
// status: "AVAILABLE"
// style: {
//  color: (2) ['#0f0f0f', '#121212']
//  icon: "0aa445e1-5f4c-45f1-ad9d-dd45973f65b8.svg"
//  image: {
//     name: "0aa445e1-5f4c-45f1-ad9d-dd45973f65b8.png"
//    opacity: 0.5
//    }
//   }
// tick: "OTTB1"
// tradeAt: "2024-04-03T03:00:00.000Z"
// type: "SPE"
// updatedAt:"2024-03-27T19:10:56.000Z"
